// The bundled spec (src/swagger.json, written by scripts/bundle-spec.cjs) as a file of its own with a content hash in its
// name, so browsers cache it and it stays out of the scripts.
export const specUrl = new URL('./swagger.json', import.meta.url).href;

// The spec's text as a document. JSON parses in milliseconds, so this runs on the page rather than in a worker.
export async function parseSpecification(text, signal) {
  if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
  let spec;
  try {
    spec = JSON.parse(text);
  } catch {
    throw new Error('Unable to parse API documentation. Please retry.');
  }
  if (!spec?.openapi || !spec?.paths) throw new Error('The API specification is not valid.');
  return spec;
}
